import type { UserProfile } from '.';

export type Donation = {
  id: string;
  charityId: string;
  confirmationId?: string;
  paymentId?: string;
  initiativeId: string;
  amountMinor: number;
  donationType: string;
  message: string;
  matchIds: string[];
  optIn: boolean;
  createdDate: string;
  status: string;
  donor?: UserProfile;
};

export const DefaultDonation: Donation = {
  id: '',
  charityId: '',
  initiativeId: '',
  amountMinor: 2500,
  donationType: '',
  message: '',
  matchIds: [],
  optIn: true,
  createdDate: new Date().toISOString(),
  status: '',
};
